// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3AMYx","title":"Header_title__3R9Gf","left":"Header_left__2w7dG","clinicName":"Header_clinicName__3qlRm"};